<template>
    <div class="flex justify-start">
        <dropdown-menu>
            <div class="py-1">
                <MenuItem>
                    <Link
                        :href="route('vehicles.edit', data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm"
                    >
                        {{ trans("vehicles.table.actions.edit") }}
                    </Link>
                </MenuItem>

                <MenuItem>
                    <a
                        @click.prevent="deactivateVehicle(data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm cursor-pointer"
                    >
                        {{
                            data.is_active
                                ? trans("vehicles.table.actions.deactivate")
                                : trans("vehicles.table.actions.activate")
                        }}
                    </a>
                </MenuItem>

                <MenuItem>
                    <a
                        @click.prevent="deleteVehicle(data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm cursor-pointer"
                    >
                        {{ trans("vehicles.table.actions.delete") }}
                    </a>
                </MenuItem>
            </div>
        </dropdown-menu>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import Swal from "sweetalert2";
import DropdownMenu from "@/Components/DropdownMenu";
import { MenuItem } from "@headlessui/vue";

export default {
    components: {
        Link,
        DropdownMenu,
        MenuItem,
    },

    props: {
        data: {
            type: Object,
        },
        index: {
            type: Number,
        },
    },

    methods: {
        deactivateVehicle(id) {
            Swal.fire({
                title: this.trans("confirmation.title"),
                text: this.data.is_active
                    ? this.trans("confirmation.deactivate_vehicle")
                    : this.trans("confirmation.activate_vehicle"),
                icon: "warning",
                iconColor: "#D64A0A",
                showCancelButton: true,
                cancelButtonColor: "#6e788188",
                confirmButtonColor: "#D64A0A",
                confirmButtonText: this.trans("confirmation.yes"),
                cancelButtonText: this.trans("confirmation.no"),
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .get(this.route("api.vehicles.deactivate", id))
                        .then(() => this.$emit("refresh"));
                }
            });
        },

        deleteVehicle(id) {
            Swal.fire({
                title: this.trans("confirmation.title"),
                text: this.trans("confirmation.delete"),
                icon: "warning",
                iconColor: "#D64A0A",
                showCancelButton: true,
                cancelButtonColor: "#6e788188",
                confirmButtonColor: "#D64A0A",
                confirmButtonText: this.trans("confirmation.yes"),
                cancelButtonText: this.trans("confirmation.no"),
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .delete(this.route("vehicles.destroy", id))
                        .then(() => this.$emit("refresh"));
                }
            });
        },
    },
};
</script>
